export default () => ({
  defaultShoppingList: null,
  shoppingLists: null,
  isShoppingListLoading: false,
  shoppingListsTypes: [],
  shoppingListCycles: [],
  productsIdsOnShoppingList: [],
});
